
const tokenKey = 'ACCESS_TOKEN_STATIC'
const accountKey = 'ACCESS_ACCOUNT'
export {
  tokenKey,
  accountKey
}
